import { get } from "@/services/axiosUitils";
import {
  IActivityLogResponseById,
  IApiErrorLogsResponse,
  IApiResponse,
  IUserAuditLogResponse,
  ILoginLogsResponse,
  ISmsLogsResponse,
} from "@/utils/types/Logs/Logs";

const base = "/tenant-core/audit";

class ActivityLogsService {
  listActivityLogs = async (
    page: number,
    pageSize: number
  ): Promise<IApiResponse> => {
    return await get<IApiResponse>(base, {
      params: {
        page,
        page_size: pageSize,
      },
    });
  };

  getActivityLog = async (id: string): Promise<IActivityLogResponseById> => {
    return await get<IActivityLogResponseById>(`${base}${id}/`);
  };

  userAuditLogsAPI = async (page?: number, pageSize?: number) => {
    return await get<IUserAuditLogResponse>(`${base}/user-audit-logs/`, {
      params: {
        page,
        page_size: pageSize,
      },
    });
  };

  getApiIssueLogsAPI = async (page?: number, pageSize?: number) => {
    return await get<IApiErrorLogsResponse>(`${base}/api-error-logs/`, {
      params: {
        page,
        page_size: pageSize,
      },
    });
  };

  getLoginLogsAPI = async (page?: number, pageSize?: number) => {
    return await get<ILoginLogsResponse>(`${base}/login-logs/`, {
      params: {
        page,
        page_size: pageSize,
      },
    });
  };

  getSmsLogsAPI = async (page?: number, pageSize?: number) => {
    return await get<ISmsLogsResponse>(`${base}/sms-logs/`, {
      params: {
        page,
        page_size: pageSize,
      },
    });
  };
}

export default new ActivityLogsService();
